// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .main-content[data-v-5d7b8c0e]  .el-loading-mask {\n  z-index: 999999;\n}\n.input-label[data-v-5d7b8c0e] {\n  display: inline-block;\n  width: 60px;\n  color: #666666;\n}\n.region-form .lable-blue[data-v-5d7b8c0e]  .el-form-item__label {\n  color: blue !important;\n}\n", ""]);
// Exports
module.exports = exports;
